export { ProductCarousel, TrendingProducts } from './TrendingProducts';
export type {
  AutomaticCarouselType,
  CarouselBackgroundImage,
  ProductCarouselItem,
  ProductCarouselProps,
  TrendingProductsProps,
} from './TrendingProducts';
